import $ from 'jquery';
require('./job_filter_pagination.js');
import '../js/header.js';
import '../scss/map.scss';
let currentLang = $('html').attr('lang').split('-')[0];

let translate = (x)=>{
    if (!x){
        return 'undefined'
    }
    if (x[currentLang]){
        return x[currentLang];
    }
    return x.en;
}

let latLngToXY = (lat, lng, svg)=>{
    let degToRad = (deg)=>deg * (Math.PI / 180)
    let x = (parseFloat(lng)+180)*(svg.width/360);
    let latRad = degToRad(parseFloat(lat));

    let mercN = Math.log(Math.tan((Math.PI/4)+(latRad/2)));
    let y = (svg.height/2)-(svg.width*mercN/(2*Math.PI));

    return {
        x: Math.floor(x*1000)/1000 + svg.leftOffset,
        y: Math.floor(y*1000)/1000 + svg.topOffset
    } 
}

$.fn.migsoWorldMap = function() {
    let data = JSON.parse($(this).find('textarea').val());
    let $svg = $(this).find('.map-svg');
    let $svgMarkers = $svg.find('.markers');
    let $backBtn = $(this).find('.--back');
    let state = {
        zoom: false,
        zoomPositions:{
            europe: "scale(5.5) translate(3%, 14%)",
            oceania:  "scale(3.5) translate(-33%, -25%)",
            northamerica: "scale(3.5) translate(31%, 10%)"
        }
    }
    let svgProps = {
        width: 1010,
        height: 650,
        markerSize: 5,
        leftLongitude: -169.6,
        topLatitude: 83.68,
        rightLongitude: 180,
        bottomLatitude: -55.55,
        leftOffset: -30,
        topOffset: 139
    }
    let createOffice = (office)=>{
        const coords = latLngToXY(office.position.lat, office.position.lng, svgProps)
        let cls = ['office']
        if (office.always_display==='1'){
            cls.push('--display-always')
        }
        $svgMarkers.append(`<g data-tooltip-position="${office.text_position}" style="transform: translate(${coords.x}px, ${coords.y}px);" class="${cls.join(' ')}" data-country="${office.country}" data-href="${office.url}">
            <circle class="office-pin"  r="1"></circle>
            <text class="office-label" x="0" y="0">${translate(office.label)}</text>
            </g>`)
    }

    data.map(country=>{
        $('#'+country.code).addClass('selectable').attr('data-country-url', country.url);
        country.offices.map(o=>{
            createOffice({...o, url: country.url})
        });

    });
    $svg.replaceWith($svg[0].outerHTML);
    $svg = $(this).find('.map-svg');
    $backBtn.click(function(e){
        e.preventDefault();
        $svg.click();
    })

    $svg.click(function(){
        $backBtn.addClass('--hidden');
        $svg.css('transform', '').removeClass('--zoomed');
        state.zoom = false;
    }).find('.selectable').click(function(e){
        if (!state.zoom){

            Object.keys(state.zoomPositions).map(group=>{
                if ($(this).hasClass(group)) {
                    $svg.css('transform', state.zoomPositions[group])
                    $backBtn.removeClass('--hidden');
                    
                    state.zoom = true;
                    $svg.addClass('--zoomed');
                    e.preventDefault();
                }
            })
        }else{
            window.location.href=$(this).data('countryUrl');
        }
        e.stopPropagation();


    })
    $svg.find('[data-href]').click(function(e){
        e.preventDefault();
        window.location.href = $(this).data('href');
    })


}

$(function(){
	$('.migso-world-map').each(function(){
		$(this).migsoWorldMap();
	})
})